import { ScreenError } from '@pidelo/web-ui';
import { useRouteError } from 'react-router';

export function RouteError() {
  const error = useRouteError();
  if (import.meta.env.DEV) console.error(error);
  return <ScreenError help="Si sigue pasando, avísale a quien maneja el equipo." />;
}
